// extracted by mini-css-extract-plugin
module.exports = {"educateMeButton":"EducateMeButton_educateMeButton__36jue"};